import { isEmpty } from 'lodash';
import Api from '@/services/Api.js';

export const setHttpToken = (token) => {
	if(isEmpty(token)) {
		Api.defaults.headers.common['Authorization'] = null;
		return;
	}
	Api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}